import { render, staticRenderFns } from "./GamePageDetail.vue?vue&type=template&id=75aba06e&scoped=true"
import script from "./GamePageDetail.vue?vue&type=script&lang=js"
export * from "./GamePageDetail.vue?vue&type=script&lang=js"
import style0 from "./GamePageDetail.vue?vue&type=style&index=0&id=75aba06e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aba06e",
  null
  
)

export default component.exports